var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9997 58.6668C53.333 58.6668 58.6663 53.3335 58.6663 40.0002V24.0002C58.6663 10.6668 53.333 5.3335 39.9997 5.3335H23.9997C10.6663 5.3335 5.33301 10.6668 5.33301 24.0002V40.0002C5.33301 53.3335 10.6663 58.6668 23.9997 58.6668H39.9997Z",
    stroke: "#15284C",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0003 26.6667C21.0548 26.6667 18.667 24.2789 18.667 21.3333C18.667 18.3878 21.0548 16 24.0003 16C26.9458 16 29.3337 18.3878 29.3337 21.3333C29.3337 24.2789 26.9458 26.6667 24.0003 26.6667Z",
    stroke: "#15284C",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.12012 50.5337L20.2668 41.707C22.3735 40.2937 25.4135 40.4537 27.3068 42.0803L28.1868 42.8537C30.2668 44.6403 33.6268 44.6403 35.7068 42.8537L46.8001 33.3337C48.8801 31.547 52.2401 31.547 54.3201 33.3337L58.6668 37.067",
    stroke: "#15284C",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload);
export default __webpack_public_path__ + "static/media/icon_upload.1c34edd690d5a187c5aaec5d75f3e16c.svg";
export { ForwardRef as ReactComponent };